module.exports = __webpack_public_path__ + "images/emoji/six.9c53db2fdb0b4bd2c96e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/six.png
// module id = qkJz
// module chunks = 24